<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formChargeAccountFirst">
        <div class="ps-2 pe-2">
          <div class="row">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="close()" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <!-- Copiar factura -->
              <app-custom-button [hidden]="previewChargeAccount" [title]="'Copiar desde'" [severity]="'contrast'"
                [icon]="'pi pi-copy'" (onClick)="openCopyChargeAccount()"></app-custom-button>

              <app-custom-modal #copyChargeAccount [label]="'Copiar Cta. Cobro'" [header]="'Copiar Cta. Cobro'"
                [inputs$]="inputsForCopyChargeAccount$" [children]="componentCopyChargeAccount" [width]="'20vw'"
                [breakpoints]="breakpointsForCopy" [closable]="true" (params)="reloadChargeAccount($event)" hidden>
              </app-custom-modal>

              <!-- Adjuntar archivos -->
              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>
              <app-custom-modal #attachFileChargeAccount [header]="'Adjuntar archivos'"
                [children]="componentAttachFiles" [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$"
                [output$]="outputForAttachFiles$" hidden></app-custom-modal>

              <!-- Vista previa -->
              <app-custom-button [title]="titlePreviewChargeAccount" [icon]="iconPreviewChargeAccount"
                [severity]="'contrast'" (onClick)="openPreviewChargeAccount()"></app-custom-button>

              <!-- Exportar excel -->
              <app-custom-button *ngIf="previewChargeAccount" [title]="'Exportar excel'" [severity]="'contrast'"
                [icon]="'pi pi-file-excel'" (onClick)="exporterDetailsPreview()"></app-custom-button>

              <!-- Imprimir -->
              <app-custom-button [hidden]="chargeAccountContract.invoiceId == 0" [title]="'Imprimir'"
                [severity]="'contrast'" [icon]="'pi pi-print'" (onClick)="openPrintRange()"></app-custom-button>

              <app-custom-modal #printRange [label]="'Imprimir'" [header]="'Imprimir'" [inputs$]="inputsForPrintRange$"
                [children]="componentPrintRange" [width]="'30vw'" [closable]="true" (params)="getParamsPrint($event)"
                hidden>
              </app-custom-modal>

              <!-- Eliminar -->
              <app-custom-button [hidden]="previewChargeAccount" [title]="'Eliminar'" [severity]="'contrast'"
                [icon]="'pi pi-trash'" (onClick)="deleteChargeAccount()"></app-custom-button>

              <!-- NUEVO -->
              <app-custom-button [hidden]="previewChargeAccount" class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'"
                [icon]="'pi pi-plus'" (onClick)="createNewChargeAccount()" [severity]="'success'" [width]="'5.5rem'"
                [variant]="undefined"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="chargeAccountContract.userNameCreate"
                [createDate]="chargeAccountContract.createDate"
                [userNameUpdate]="chargeAccountContract.userNameUpdate"
                [updateDate]="chargeAccountContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
        </div>
        <div class="ps-2 pe-2">
          <div [hidden]="previewChargeAccount">
            <!-- Formulario Captura -->
            <div class="row mt-1 d-flex justify-content-between">
              <div class="col-lg-8 col-md-12 col-sm-12 col-12 pe-lg-5 pe-md-2">
                <div class="row">
                  <div class="custom-container col-lg-4 col-md-2 col-sm-6 col-12">
                    <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                      [required]="true" [recovery]="true"
                      (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-4 col-md-2 col-sm-6 col-12">
                    <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                      [required]="true" [recovery]="true"
                      (onChangeSelect)="getEnterprise($event, true)"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-4 col-6">
                    <app-custom-select formControlName="bussinessDocumentsTypeId" [labelText]="'Tipo'"
                      [list]="listBussinessDocumentsTypes" [required]="true" [recovery]="true"
                      (onChangeSelect)="getBussinessDocumentsType($event, true)"></app-custom-select>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-2 col-6">
                    <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                      [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-6">
                    <app-custom-datepicker formControlName="dateInvoice" [labelText]="'Fecha'" [required]="true"
                      (onChangeDate)="validatePeriodDate()"></app-custom-datepicker>
                  </div>
                  <div class="custom-container col-lg-2 col-md-2 col-sm-3 col-6">
                    <app-custom-datepicker formControlName="dateExpiration" [labelText]="'Vencimiento'"
                      [required]="true" (onChangeDate)="validateDateExpiration()"></app-custom-datepicker>
                  </div>
                  <div class="custom-container col-lg-4 col-md-6 col-sm-6 col-12">
                    <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                      [required]="true" [class]="getClass('client')" (onChangeSelect)="getClient($event, true)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="custom-container col-lg-4 col-md-6 col-sm-6 col-12">
                    <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'"
                      [list]="filteredCostCenters" [class]="getClass('costCenter')"
                      (onChangeSelect)="getCostCenter($event, true)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="custom-container col-lg-2 col-md-6 col-sm-6  col-sm-6">
                    <app-custom-autocomplete formControlName="zoneId" [labelText]="'Zona'" [required]="true"
                      [list]="listZones" (onChangeSelect)="getZone($event)"></app-custom-autocomplete>
                  </div>
                  <div class="custom-container col-lg-4 col-md-6 col-sm-6 col-sm-6">
                    <app-custom-autocomplete class="custom-field" formControlName="sellerId" [labelText]="'Vendedor'"
                      [required]="true" [list]="listSellers"></app-custom-autocomplete>
                  </div>
                  <div class="custom-container col-lg-6 col-md-12 col-sm-12 col-12">
                    <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                      [rows]="1" [maxLength]="250"></app-custom-textarea>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-sm-12 col-12 ps-md-2 pt-lg-0 pt-sm-2">
                <div class="row">
                  <div class="col-lg-3 col-md-2 col-sm-2 col-6">
                    <app-custom-tag [label]="'Estado'" [severity]="severityState"
                      [value]="chargeAccountStateString"></app-custom-tag>
                  </div>
                  <div class="col-lg-9 col-md-6 col-sm-10 col-12 d-flex align-items-end mt-2 gap-2">
                    <app-custom-button [title]="titleStateChargeAccount" [icon]="iconStateChargeAccount"
                      [disabled]="this.chargeAccountContract.swBlock"
                      (onClick)="changeStateChargeAccount()"></app-custom-button>
                    <app-custom-button [hidden]="visibleAnnul" [title]="'Anular'" [icon]="'pi pi-ban'"
                      [severity]="'warn'" (onClick)="openAnnulChargeAccount()"></app-custom-button>

                    <app-custom-modal #annulChargeAccount [label]="'Anular Cta.Cobro'" [header]="'Anular Cta.Cobro'"
                      [inputs$]="inputsForAnnulChargeAccount$" [children]="componentAnnulChargeAccount" [width]="'40vw'"
                      [closable]="true" (params)="reloadChargeAccount($event)" hidden>
                    </app-custom-modal>

                    <app-custom-checkbox class="mb-1" formControlName="swBlock" [labelText]="'Bloq.'"
                      (onChangeCheckBox)="blockChargeAccount($event)"></app-custom-checkbox>

                    <app-custom-checkbox class="mb-1 ms-2" formControlName="swCopied"
                      [labelText]="'Fra. Copiada'"></app-custom-checkbox>
                    <app-custom-checkbox class="mb-1" formControlName="swManual"
                      [labelText]="'Fra. Manual'"></app-custom-checkbox>
                  </div>
                  <div class="custom-container col-lg-2 col-md-4 col-sm-6">
                    <app-custom-tag [label]="''" [value]="bussinessDocumentsTypeIsRental"></app-custom-tag>
                  </div>
                  <div class="custom-container col-lg-4 col-md-4 col-sm-6">
                    <app-custom-select class="custom-field" formControlName="chargeAccountOperationId"
                      [labelText]="'Operación'" [list]="listChargeAccountOperation"
                      (onChangeSelect)="changeOperation($event)"></app-custom-select>
                  </div>
                  <div class="col-lg-6 col-md-4 col-sm-6 col-12 d-flex align-items-end mt-2 my-lg-0 gap-2">
                    <app-custom-chip [label]="'Corte: ' + invoicingCutoffCode" />
                    <app-custom-chip [label]="'Movto: ' + movementCode" />
                    <app-custom-chip [label]="'Cta.C.Cop: ' + (invoiceOriginConsecutive ?? '')" />
                  </div>
                  <div class="custom-container"
                    [ngClass]="enableSetChargeAccountWalletType ? 'col-lg-5  col-md-4 col-sm-6' : 'col-lg-6 col-md-4 col-sm-6'">
                    <app-custom-select class="custom-field" formControlName="chargeAccountWalletTypeId"
                      [labelText]="'Tipo Cartera'" [list]="listChargeAccountWalletType"></app-custom-select>
                  </div>
                  <div *ngIf="enableSetChargeAccountWalletType"
                    class="col-lg-1 col-md-1 col-sm-1 col-2 d-flex align-items-end">
                    <app-custom-button [title]="'Cambiar Tipo Cartera'" [label]="''" [disabled]="disabledForm"
                      (onClick)="setChargeAccountWalletType()" [severity]="'success'"
                      [icon]="'pi pi-sync'"></app-custom-button>
                  </div>
                  <div class="col-lg-6 col-md-12 col-sm-12 col-12 m-2 d-flex justify-content-end align-items-end">
                    <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm"
                      [variant]="undefined" (onClick)="send()"></app-custom-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Vista Previa -->
          <div *ngIf="previewChargeAccount">
            <app-custom-progress-bar [show]="visibleLoading" [heightProgress]="'0.3rem'"></app-custom-progress-bar>
            <div class="d-flex justify-content-center mt-2">
              <div id="container-format" [hidden]="visibleLoading">
                <app-print-charge-account id="preview-charge-account" [companyId]="companyId"
                  [formatModel]="formatModel" [chargeAccountModels]="chargeAccountPrintModel"
                  [exporterChargeAccountDetailsPreview]="exporterChargeAccountDetailsPreview"
                  [chargeAccountTraffic]="'Vista Previa'" [editFormat]="false" [focusText]="false"
                  (finishLoadingPrintChargeAccount)="visiblePreview($event)">
                </app-print-charge-account>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div [hidden]="previewChargeAccount">
        <!-- Detalle de la Cta. Cobro -->
        <p-accordion [(value)]="activePanel" value="none" class="accordion-detail" [transitionOptions]="'0ms'"
          (onClose)="toggleAccordion()" (onOpen)="toggleAccordion()">
          <p-accordion-panel value="0">
            <p-accordion-header>
              <div class="d-flex align-items-center gap-2 w-100">
                <span class="flex-grow-1"> Detalle de la Cta.Cobro ({{quantityDetails}}) </span>
                <div class="mx-3 d-flex gap-2" (click)="$event.stopImmediatePropagation()"
                  (mousedown)="$event.stopImmediatePropagation()">
                  <!-- Detalle -->
                  <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [width]="'7rem'"
                    [disabled]="disabledForm" (onClick)="newDetail($event)">
                  </app-custom-button>
                </div>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <div class="row detail-container container-detail" [hidden]="chargeAccountContract.invoiceId == 0"
                *ngIf="showAccordion">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <app-charge-account-detail #chargeAccountDetail id="chargeAccountDetail"
                    [chargeAccountModel]="chargeAccountContract" [disabled]="disabledForm" [isFormView]="isFormView"
                    (updateChargeAccount)="getUpdateChargeAccount($event)">
                  </app-charge-account-detail>
                </div>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
        <!-- Valores e impuestos de la factura -->
        <form class="needs-validation mt-1 container-style" [formGroup]="formChargeAccountFooter">
          <div class="col-lg-12 col-12">
            <div class="row mt-1 ms-2 me-2 mb-1 d-flex justify-content-end">
              <div class="col-lg-3 col-12">
                <div class="row">
                  <div class="custom-container col-lg-6 col-6">
                    <app-custom-input-decimal formControlName="paymentValue"
                      [labelText]="'Abonos'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-6 col-6">
                    <app-custom-input-decimal formControlName="residueValue"
                      [labelText]="'Saldo'"></app-custom-input-decimal>
                  </div>
                </div>
              </div>
              <div class="col-lg-7 col-12">
                <div class="row">
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="subtotalValue"
                      [labelText]="'Subtotal'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="discountValue"
                      [labelText]="'Dcto Gral.'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="totalValue"
                      [labelText]="'Total'"></app-custom-input-decimal>
                  </div>
                  <div class="custom-container col-lg-3 col-md-4 col-sm-4 col-6">
                    <div class="custom-container col-lg-12 col-md-12 col-sm-12 col-12">
                      <app-custom-tag [label]="'Vr. A Pagar'"
                        [value]="( chargeAccountContract.valueToPay | number:'1.2-2') ?? '0.00'"></app-custom-tag>
                    </div>
                  </div>
                </div>
              </div>
              <div class=" col-lg-1 col-md-4 col-sm-4 col-12 d-flex align-items-end justify-content-end">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-2">
                    <app-custom-button [label]="'Descuento'" [icon]="'pi pi-percentage'" [severity]="'success'"
                      [width]="'6.5rem'" (onClick)="openGeneralConcept()"></app-custom-button>
                    <app-custom-modal #generalDiscount [label]="'Descuento'" [header]="'Descuento por Concepto'"
                      [inputs$]="inputsForGeneralDiscount$" [children]="componentGeneralDiscount" [width]="'85vw'"
                      [closable]="false" [focusShow]="false" (params)="reloadChargeAccount($event)" hidden>
                    </app-custom-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</section>
<!-- Imprimir Factura -->
<div id="container-print-invoice">
  <app-print-charge-account *ngIf="printChargeAccountFormat" id="print-invoice" [companyId]="companyId"
    [formatModel]="formatModel" [chargeAccountModels]="chargeAccountPrintModel"
    [chargeAccountTraffic]="chargeAccountTraffic" [editFormat]="false" [focusText]="false"
    (finishLoadingPrintChargeAccount)="finishLoading($event)">
  </app-print-charge-account>
</div>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>